module.exports = __webpack_public_path__ + "img/9788982739088.10fee9c8.jpg";